App.controller('ProfileProtegesListsCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'profileProtegesService', function ($scope, $sce, $state, $http, Config, $mdDialog, profileProtegesService) {
    $scope.page = 'profile_proteges_lists';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja rodzina';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    $scope.$emit('loaderActivated', {status: true, info: 'Ładuje dane Twoich podopiecznych...'});

    $scope.userData = JSON.parse(window.sessionStorage.getItem('userObject'));
    $scope.partnerExists = $scope.userData.partnerExists;

    $scope.data = {
        "pageNumber": 0
    }
    profileProtegesService.dataProtegesUser($scope.data).then(function (data) {
        $scope.userProtegesData = data.data.data;
        $scope.canAddChild = ($scope.userProtegesData.length < $scope.userData.benefit.children) ? true : false;
        $scope.canAddPartner = ($scope.userData.benefit.partner > 0) ? true : false;

        $scope.data = {
            "pageNumber": 0
        }
        profileProtegesService.allProtegesUser($scope.data).then(function (data) {
            $scope.allProtegesData = data.data.data;
            console.log($scope.allProtegesData);
            $scope.$emit('loaderActivated', {status: false});

            $scope.adultChildCount = 0;
            $scope.partnerCount = 0;
            $scope.deletedCount = 0;
            for (var a = 0; a < $scope.allProtegesData.length; a++) {
                if ($scope.allProtegesData[a].status !== 'DELETED' && $scope.allProtegesData[a].type === 'ADULT_CHILD') {
                    $scope.adultChildCount++;
                } else if ($scope.allProtegesData[a].status !== 'DELETED' && $scope.allProtegesData[a].type === 'PARTNER') {
                    $scope.partnerCount++;
                } else if ($scope.allProtegesData[a].status === 'DELETED') {
                    $scope.deletedCount++;
                }
            }

            console.log($scope.adultChildCount, $scope.partnerCount, $scope.deletedCount);
        });
    });

    $scope.delete = function(id) {
		$scope.showPopUp(null, id);
    }

    $scope.removeFromServer = function(id) {
        profileProtegesService.deleteProtegesUser(id).then(function (data) {
            if (data.status === 200) {

                $scope.data = {
                    "pageNumber": 0
                }
                profileProtegesService.dataProtegesUser($scope.data).then(function (data) {
                    $scope.userProtegesData = data.data.data;
                });
            }
        });
    }

    $scope.showPopUp = function(ev, id) {
        $mdDialog.show({
            controller: PopUpConfirmCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/confirm-small.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                id: id,
                head: '',
                content: 'Czy na pewno chcesz usunąć podopiecznego?'
            }
        }).then(function(data) {
            if (data.confirm) {
                $scope.removeFromServer(data.id);
            }
        }, function() {
            
        });
    }

    function PopUpConfirmCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;
        console.log($scope.locals);

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide({
                id: $scope.locals.id,
                confirm: true
            });
        };
    }
}]);